import { ClipboardList, Package, Ticket } from 'lucide-react'
import { AppPaths } from '@/config/app-paths'
import type { StaffNavContext } from '../staff-nav-context'
import { group, leaf, type StaffNavGroup, type StaffNavNode } from '../nav-node'

export function buildOperationsGroup(ctx: StaffNavContext): StaffNavGroup | null {
  const children: StaffNavNode[] = []

  if (ctx.showSupervisorGatePass) {
    children.push(
      leaf(
        'supervisor_gate_pass',
        'My Gate Pass Requests',
        AppPaths.supervisorGatePass,
        Ticket,
        ['gate', 'pass', 'visitor', 'supervisor', 'gate pass', 'requests'],
        { activeWhenPrefix: true },
      ),
    )
  }

  if (ctx.showHrGatePass) {
    children.push(
      leaf(
        'hr_gate_pass',
        'Gate pass requests',
        AppPaths.hrGatePasses,
        Ticket,
        ['gate', 'pass', 'hr', 'issue', 'gate pass'],
        { activeWhenPrefix: true },
      ),
    )
  }

  if (ctx.showAdminGatePass) {
    children.push(
      leaf(
        'admin_gate_pass',
        'Gate Pass Approvals',
        AppPaths.adminGatePasses,
        Ticket,
        ['gate', 'pass', 'approval', 'admin', 'approve gate passes'],
        { activeWhenPrefix: true },
      ),
    )
  }

  if (ctx.showStockApprovalsNav) {
    children.push(
      leaf(
        'stock_approvals',
        'Stock Approvals',
        AppPaths.adminStockApprovals,
        ClipboardList,
        ['stock', 'approval', 'requisition', 'purchase', 'materials', 'approve'],
        { activeWhenPrefix: true },
      ),
    )
  }

  if (ctx.showSupervisorMaterialRequest) {
    children.push(
      leaf(
        'supervisor_material_request',
        'Material Request',
        AppPaths.supervisorMaterialRequest,
        ClipboardList,
        ['material', 'requisition', 'uniform', 'ppe', 'supervisor'],
        { activeWhenPrefix: true },
      ),
    )
  }

  if (ctx.showStocksNav) {
    children.push(
      leaf(
        'stocks',
        'Stocks & Inventory',
        AppPaths.adminStocks,
        Package,
        ['stocks', 'inventory', 'uniform', 'requisition', 'store', 'materials'],
        { activeWhenPrefix: true },
      ),
    )
  }

  return group(
    'operations',
    'Operations',
    Package,
    ['operations', 'stocks', 'gate pass', 'material'],
    children,
  )
}
